<template>
	<div class="row">
		<div class="col-12 d-flex flex-row align-items-center justify-content-between">
			<h1>{{ $t('workflows') }}</h1>
			<router-link class="btn btn-primary mb-3" to="/settings/workflows/edit">
				{{ $t('new') }}
			</router-link>
		</div>
		<div class="col-12">
			<Table
				:loading="loading"
				:submitting="submitting"
				:cols="[
					{ key: 'title', heading: $t('name'), size: 4 },
					{ key: 'note', heading: $t('description'), size: 6 },
                    {
                    	key: 'status',
                    	heading: $t('status'),
                    	size: 2,
                    	sortable: false ,
						cb: (el) => {
							if(el.status == 1) return $t('active');
							if(el.status == 2) return $t('disabled');
							if(el.status == 3) return $t('deleted');
							return ''
						}
                    }
				]"
				:data="workflows"
				breakpoint="md"
				:filters="{
                    ...filters,
                    page: filters.page,
                    page_size: filters.page_size,
                }"
				:searchable="true"
				:scrollPaginate="true"
				@selectItem="workflow => $router.push(`/settings/workflows/edit/${workflow.id}`)"
				@refresh="refresh"
                @toPage="toPage"
                :allowRightClick="false"
			>
                <template v-slot:header>
                    <div class="list-group-item align-items-center">

						<div class="form-inline">
							<!-- Filter by Role -->
							<CheckboxInput
								:value="filters.just_active"
								@input="value => refresh({ just_active: value, page: 1 })"
								:label="$t('show-active-workflows-only')"
								class="ml-4 align-items-center"
							/>
						</div>

                    </div>
                </template>
            </Table>
		</div>
	</div>
</template>

<script>
import Table from "src/components/Table/Table.vue";

export default {
    components: {
    	Table
	},
	data() {
		return {
			loading: true,
			submitting: false,
			filters: {
				page: 1,
				page_size: 30,
				total: 0,
				search: '',
                just_active: true
			},
            total_count: 0,
			workflows: [],
            selectedWorkflow: null
		};
	},
	mounted() {
		this.getList().then(() => { this.loading = false });
	},
	methods: {
		getList() {
			if (this.submitting) return
			this.submitting = true

			return this.$cfetch(`${this.$settings.APIBaseURL}/workflows/list`, {
				method: 'GET',
				data: this.filters,
			})
			.then(res => {
				if (res.status !== 'SUCCESS') throw new Error('Unexpected error listing workflows');
				this.workflows = res.results;
				this.filters.page = res.pagination.page;
                this.filters.page_size = res.pagination.page_size;
                this.filters.total = res.pagination.total;
			})
			.catch(err => {
				this.$log.error.call(this, err)
				this.$store.commit('openDialog', {
					title: this.$t('something-went-wrong'),
					content: this.$t('error-listing-workflows')
				})
			})
			.finally(() => {
				this.submitting = false
			})
		},
		refresh(filters) {
			this.filters = { ...this.filters, ...filters }
			this.getList()
		},
        toPage(pageNo) {
            this.filters.page = pageNo;
            this.getList()
        }

	},
	computed: {}
};
</script>
